import { render, staticRenderFns } from "./AllianceSetupCommn.vue?vue&type=template&id=b6671884&scoped=true"
import script from "./AllianceSetupCommn.vue?vue&type=script&lang=js"
export * from "./AllianceSetupCommn.vue?vue&type=script&lang=js"
import style0 from "./AllianceSetupCommn.vue?vue&type=style&index=0&id=b6671884&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6671884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6671884')) {
      api.createRecord('b6671884', component.options)
    } else {
      api.reload('b6671884', component.options)
    }
    module.hot.accept("./AllianceSetupCommn.vue?vue&type=template&id=b6671884&scoped=true", function () {
      api.rerender('b6671884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/components/AllianceSetupCommn.vue"
export default component.exports